// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qBps","newExpiryDate":"styles_newExpiryDate__3xshi","footer":"styles_footer__txDhr"};